import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "t6_table_b" }

import { reactive } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()

const data = reactive({
    userInfo: {} as any,
})
data.userInfo = store.state.userInfomation


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "t6_title_h1" }, " 我的信息 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("th", null, "姓名", -1)),
              _createElementVNode("td", null, _toDisplayString(data.userInfo.userName), 1),
              _cache[1] || (_cache[1] = _createElementVNode("th", null, "手机号码", -1)),
              _createElementVNode("td", null, _toDisplayString(data.userInfo.userMobile), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("th", null, "证件类型", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("td", null, "身份证", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, "证件号码", -1)),
              _createElementVNode("td", null, _toDisplayString(data.userInfo.certNo), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})